import { Chip, Tooltip } from "@mui/material";
import PendingIcon from "@mui/icons-material/Pending";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import CancelIcon from "@mui/icons-material/Cancel";
import BlockIcon from "@mui/icons-material/Block";
import ArchiveIcon from "@mui/icons-material/Archive";
import PartialCircleIcon from "@mui/icons-material/DonutLarge";

/**
 * Componente para mostrar el estado de un batch de forma visual
 * @param {string} status - Estado del batch
 * @param {string} size - Tamaño del chip: "small" | "medium" (default: "small")
 * @param {boolean} showIcon - Si mostrar ícono (default: true)
 */
const BatchStatusChip = ({ status, size = "small", showIcon = true }) => {
  const statusConfig = {
    pending: {
      label: "Pendiente",
      color: "warning",
      icon: <PendingIcon />,
      description: "Batch creado, esperando procesamiento",
    },
    running: {
      label: "Procesando",
      color: "info",
      icon: <PlayCircleIcon />,
      description: "Cálculo en progreso",
    },
    completed: {
      label: "Completado",
      color: "success",
      icon: <CheckCircleIcon />,
      description: "Cálculo completado, listo para revisión",
    },
    failed: {
      label: "Error",
      color: "error",
      icon: <ErrorIcon />,
      description: "Error durante el cálculo",
    },
    approved: {
      label: "Aprobado",
      color: "success",
      icon: <CheckCircleIcon />,
      description: "Batch aprobado (≥90% distribuciones aprobadas)",
      variant: "filled",
    },
    partially_approved: {
      label: "Parcialmente Aprobado",
      color: "info",
      icon: <PartialCircleIcon />,
      description: "Algunas distribuciones aprobadas (<90%)",
      variant: "outlined",
    },
    rejected: {
      label: "Rechazado",
      color: "error",
      icon: <CancelIcon />,
      description: "Batch rechazado completamente",
    },
    cancelled: {
      label: "Cancelado",
      color: "default",
      icon: <BlockIcon />,
      description: "Batch cancelado manualmente",
    },
    superseded: {
      label: "Reemplazado",
      color: "default",
      icon: <ArchiveIcon />,
      description: "Batch reemplazado por uno nuevo (force recalculation)",
    },
  };

  const config = statusConfig[status] || {
    label: status,
    color: "default",
    icon: <PendingIcon />,
    description: status,
  };

  const chipComponent = (
    <Chip
      label={config.label}
      color={config.color}
      size={size}
      icon={showIcon ? config.icon : undefined}
      variant={config.variant || "filled"}
      sx={{
        fontWeight: ["approved", "rejected"].includes(status) ? "bold" : "medium",
      }}
    />
  );

  // Si no hay descripción, retornar solo el chip
  if (!config.description) {
    return chipComponent;
  }

  // Retornar con tooltip
  return (
    <Tooltip title={config.description} arrow placement="top">
      {chipComponent}
    </Tooltip>
  );
};

export default BatchStatusChip;
